import React from "react";
import "./SubTabs.css";

export default function SubTabs({ tabs, activeTab, onTabChange }) {
  return (
    <div className="sub-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`stab ${activeTab === tab.key ? "stab-active" : ""}`}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
